import { Route, Routes } from "react-router-dom";
import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import TicketsEntryPage from "~/entry-pages/space/tickets/tickets/TicketsEntryPage";

type Props = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

export function TicketsRoutes({ space, scope }: Props) {
  return (
    <Routes>
      <Route
        path="/"
        element={<TicketsEntryPage space={space} scope={scope} />}
      />
    </Routes>
  );
}
